import React from 'react'

const TableHeader = ({children}) => {
    return (
        <>
           <thead className="bg-gray ">{children}</thead>
        </>
    )
}

export default TableHeader
